export const incidentTypeInputName = 'Incident Type ID';
